module.exports = __webpack_public_path__ + "static/media/ic-facebook.7b9a971d.svg";